import { Component, OnInit, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'app-navigation',
    templateUrl: './navigation.component.html',
    styleUrls: ['./navigation.component.scss'],
    standalone: false
})
export class NavigationComponent implements OnInit {

  @Output() buttonClick = new EventEmitter<any>();

  constructor() { }

  ngOnInit(): void {
  }

  emitButtonClick(event: any){
    this.buttonClick.emit(event);
  }
}
